import { MessageCircle } from "lucide-react";

interface FloatingChatButtonProps {
  onClick: () => void;
  unreadCount: number;
}

export function FloatingChatButton({ onClick, unreadCount }: FloatingChatButtonProps) {
  return (
    <button
      onClick={onClick}
      className="w-14 h-14 lg:w-16 lg:h-16 bg-primary hover:bg-primary/90 text-white rounded-full shadow-2xl hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] transition-all hover:scale-110 flex items-center justify-center relative animate-in fade-in slide-in-from-bottom-5 duration-500"
      aria-label="Abrir chat"
      style={{
        position: "fixed",
        bottom: "6rem",
        right: "1rem",
        zIndex: 99999,
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.3)"
      }}
    >
      <MessageCircle className="w-6 h-6 lg:w-7 lg:h-7" />
      {Number(unreadCount) > 0 && (
        <span 
          className="min-w-[20px] h-5 px-1.5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-white shadow-lg animate-pulse"
          style={{
            position: "absolute",
            top: "-4px",
            right: "-4px"
          }}
        >
          {Number(unreadCount) > 99 ? "99+" : (Number(unreadCount) || 0)}
        </span>
      )}
    </button>
  );
}